// Used by useShowCompatibilityBanner to warn users on OS versions that
// can't complete account setup (see sign_up.operating_system_alert copy).
export const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
export const isAndroid = /Android/i.test(navigator.userAgent);

export const iosVersionMatch = navigator.userAgent.match(/OS (\d+)_/);
export const androidVersionMatch = navigator.userAgent.match(/Android (\d+)/);

// Oldest OS versions still able to complete the onboarding v5 experience —
// see sign_up.operating_system_alert copy for the user-facing warning.
export const MIN_COMPATIBLE_IOS_VERSION = 15;
export const MIN_COMPATIBLE_ANDROID_VERSION = 9;
